<template>
  <div class="flex min-h-screen">
    <RouterView />
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
